module.exports = __webpack_public_path__ + "k-dead.png?7b04b31d2d537b2277a5ff4eec01fdb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k-dead.png
// module id = 50
// module chunks = 0